<template>
  <header
    id="header"
    :class="{ 'header--compact': isCompact }"
    @click.prevent="isMenuShow = false"
  >
    <div class="header__inner">
      <a class="header__logo" href="https://www.ctbcinvestments.com/" target="_blank" @click.stop>
      </a>

      <!-- PC -->
      <nav class="header__menu">
        <ul>
          <li class="header__menu__item">
            <a href="#" @click.prevent="scrollToElement('slugger')"
              >美國大聯盟</a
            >
          </li>
          <li class="header__menu__item">
            <a href="#" @click.prevent="scrollToElement('scout')">最佳MVP</a>
          </li>
          <li class="header__menu__item">
            <a href="#" @click.prevent="scrollToElement('overview')"
              >基金特色</a
            >
          </li>
          <li class="header__menu__item">
            <a href="#" @click.prevent="scrollToElement('entry')">輕鬆入隊</a>
          </li>
          <li
            class="header__menu__item header__menu__item-close"
            v-if="isCompact"
          >
            <a class="text-hide" href="#" @click.prevent>關閉</a>
          </li>
        </ul>
      </nav>

      <!-- MB -->
      <transition name="fade" mode="out-in">
        <nav
          v-if="isMenuShow"
          class="header__menu mb"
          :class="{ 'header__menu--show': isMenuShow }"
        >
          <ul>
            <li class="header__menu__item">
              <a href="#" @click.prevent="scrollToElement('slugger')"
                >美國大聯盟</a
              >
            </li>
            <li class="header__menu__item">
              <a href="#" @click.prevent="scrollToElement('scout')">最佳MVP</a>
            </li>
            <li class="header__menu__item">
              <a href="#" @click.prevent="scrollToElement('overview')"
                >基金特色</a
              >
            </li>
            <li class="header__menu__item">
              <a href="#" @click.prevent="scrollToElement('entry')">輕鬆入隊</a>
            </li>
            <li
              class="header__menu__item header__menu__item-close"
              v-if="isCompact"
            >
              <a class="text-hide" href="#" @click.prevent>關閉</a>
            </li>
          </ul>
        </nav>
      </transition>
      <div
        class="header__toggler"
        :class="{ 'header__toggler--show': isMenuShow }"
      >
        <a href="#" @click.stop.prevent="openMenu">
          <span></span>
          <span></span>
          <span></span>
        </a>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useMainStore } from '@/store/main';
import { mixins } from '@/utils/mixins';
export default {
  name: 'Header',
  mixins: [mixins],
  props: {},
  data: () => {
    return {
      isCompact: false,
      isMenuShow: false,
    };
  },
  computed: {
    ...mapState(useMainStore, ['isMobile']),
  },
  methods: {
    ...mapActions(useMainStore, ['openPopup']),
    // moveTo(elemName) {
    //   const { jumpToTarget } = this;
    //   const elem = document.querySelector(elemName);
    //   jumpToTarget(elem);
    // },
    openMenu() {
      this.isMenuShow = !this.isMenuShow;

      // if (this.isMenuShow) {
      //   // 記錄當前滾動位置
      //   const scrollY = window.scrollY;
      //   document.body.style.position = 'fixed';
      //   document.body.style.top = `-${scrollY}px`;
      //   document.body.style.width = '100%';
      // } else {
      //   // 恢復滾動位置
      //   const scrollY = Math.abs(parseInt(document.body.style.top || '0', 10));
      //   document.body.style.position = '';
      //   document.body.style.top = '';
      //   document.body.style.width = '';
      //   window.scrollTo(0, scrollY);
      // }
    },
    scrollToElement(id) {
      const element = document.getElementById(id);
      const header = document.getElementById('header');

      if (element) {
        const headerHeight = header ? header.offsetHeight : 0;
        const offsetTop = element.offsetTop - headerHeight;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    },
  },
  created() {
    window.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) this.isMenuShow = false;
    });
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        this.isCompact = !entries[0].isIntersecting;
      },
      { threshold: 0.25 }
    );

    const target = document.getElementById('home');
    observer.observe(target);
  },
};
</script>

<style lang="scss" scoped>
#header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 90px;
  background-color: #0d7c7c;
  z-index: 3;
  @include tabletX {
    height: 90px;
    // height: vwX(163);
  }
  @include tablet {
    height: vwM(163);
  }

  .header__inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 1720px;
    height: 100%;
    margin: 0 auto;
    @include tablet {
    }
  }

  .header__logo {
    width: 208px;
    height: 51px;
    background-image: url('../assets/images/logo_img.png');
    background-repeat: no-repeat;
    background-size: 208px 51px;
    background-position: center top;
    margin-left: 20px;
    @include tabletX {
      width: vwX(340);
      height: vwX(83);
      background-size: vwX(340) vwX(83);
      margin-left: vwX(30);
    }
    @include tablet {
      width: vwM(340);
      height: vwM(83);
      background-size: vwM(340) vwM(83);
      margin-left: vwM(30);
    }
  }
  .header__menu {
    &.header__menu--show {
      ul {
        @include tablet {
          display: block;

          width: 100%;
          height: 100vh;
          background-color: rgba(13, 124, 124, 0.5);
          border-top: vwM(5) solid #fff;
          position: absolute;
          top: vwM(160);
          left: 0;
        }
      }
    }
    ul {
      display: flex;
      @include tablet {
        display: none;
      }
    }

    &.mb {
      @include tablet {
        padding-top: vwM(40);
      }
      ul {
        @include tablet {
          padding-right: vwM(18);
          padding-top: vwM(35);
        }
      }
    }
  }
  .header__menu__item {
    position: relative;
    margin: 0 28px;
    @include tablet {
      text-align: right;
    }
    &:nth-child(4) {
      &::after {
        display: none;
      }
    }
    &::after {
      display: inline-block;
      content: '';
      width: 1px;
      height: 25px;
      background-color: #fff;
      position: absolute;
      top: -1px;
      left: 104px;
      @include tablet {
        display: none;
      }
    }
    &:nth-child(1) a {
      position: relative;
      left: -30px;
      @include tabletX {
        left: vwX(-30);
      }
      @include tablet {
        left: 0;
      }
    }
    &:nth-child(2) a {
      position: relative;
      left: -15px;
      @include tabletX {
        left: vwX(-15);
      }
      @include tablet {
        left: 0;
      }
    }
    a {
      font-size: 19px;
      letter-spacing: letterSpacing(50, 19px);
      color: #fff;
      @include tablet {
        font-size: vwM(40);
        letter-spacing: letterSpacing(50, vwM(40));
        line-height: lineHeight(40, 160);
      }
    }
    &.header__menu__item-close {
      display: none;
    }
  }

  .header__toggler {
    display: none;
    @include tablet {
      display: block;
      margin-right: vwM(40);
    }
    span {
      @include tabletX {
        display: block;
        width: vwX(98);
        height: vwX(7);
        background-color: #86bebe;
        margin: vwX(25) 0;
        transition-duration: 0.35s;
      }
      @include tablet {
        width: vwM(98);
        height: vwM(7);
        margin: vwM(25) 0;
      }
    }
    &--show {
      span {
        &:nth-child(1) {
          transform: translateY(vwM(17)) rotate(45deg);
        }

        &:nth-child(2) {
          display: none;
        }

        &:nth-child(3) {
          transform: translateY(vwM(-17)) rotate(-45deg);
        }
      }
    }
  }
}
</style>
